import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import '../signup/SignUp.css'
import useApi from '../../customHook/useApi'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { login } from '../../redux/slices/authSlice'
import { setUserIdEmail, setUserProfile } from '../../redux/slices/userSlice'
// import { login } from '../../store/authSlice'
// import { setUserProfile, setUserIdEmail } from '../../store/userSlice'

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch(); // to dispatch actions
    const { postFormData } = useApi('https://codezens.com/luststory/index.php/api');
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const validateForm = () => {
        if (!formData.email) {
            toast.error('Email is required.');
            return false;
        }

        if (!formData.password) {
            toast.error('Password is required.');
            return false;
        }

        return true;
    }
    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            postFormData('/login', formData).then((response) => {
                if (response && response.status === 1) {
                    const { result } = response;
                    
                    // Dispatch actions to update auth and user slice
                    dispatch(login({
                        role: result.type, // 'Customer' or 'Admin' or other roles
                        userDetails: result // you can store the entire result in userDetails
                    }));

                    dispatch(setUserIdEmail({
                        id: result.user_id,
                        email: result.email
                    }));

                    dispatch(setUserProfile({
                        name: result.name,
                        email: result.email,
                        profileImage: result.user_image
                    }));
                    navigate('/home');
                } else {
                    toast.error(response.result);
                }
            }).catch(err => {
                toast.error(err.message || 'Something went wrong!');
            })
        }
    }

    return (
        <div className='login-section w-100 '>
            <div className='login-box position-relative d-flex flex-wrap align-content-center justify-content-center'>
                <h6 className='text-center'>Login</h6>
                <div className='login-form w-100'>
                    <div className=' btn-box w-100'>
                        <form className='form-section' onSubmit={handleSubmit}>
                            <div className="col-md-12">
                                <label htmlFor="username" className="d-none form-label">Email</label>
                                <input
                                    type="emal"
                                    className="form-control"
                                    name="email"
                                    id="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Email"
                                />
                            </div>
                            <div className="col-md-12">
                                <label htmlFor="username" className="d-none form-label">Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    name="password"
                                    id="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    placeholder="Password"
                                />
                            </div>
                            <p className='text-center mt-4'>
                                <button type="submit" className="btn btn-primary">Login</button>
                            </p>
                        </form>
                        <p className='text-center'>Does not have an account? <Link rel='stylesheet' to="/signup">Sign up</Link></p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login
